var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4687 9.78027C10.3219 9.63374 10.25 9.44249 10.25 9.24999C10.25 9.05749 10.3232 8.86624 10.4697 8.71968L13.4406 5.74999L0.75 5.74999C0.335937 5.74999 -2.00527e-07 5.41249 -2.18557e-07 4.99999C-2.36588e-07 4.58749 0.335937 4.24999 0.75 4.24999L13.4406 4.24999L10.4709 1.2803C10.178 0.987332 10.178 0.512801 10.4709 0.219676C10.7639 -0.0734496 11.2384 -0.0732932 11.5316 0.219676L15.7816 4.46967C16.0745 4.76264 16.0745 5.23717 15.7816 5.5303L11.5316 9.7803C11.2375 10.0732 10.7625 10.0732 10.4687 9.78027Z",
    fill: "#B44D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.5630945a2a37502a872dc84c99beb3f9.svg";
export { ForwardRef as ReactComponent };